import { apiClient } from ".";
import { useMutation } from "@tanstack/react-query";
import { captureException } from "@sentry/react";

export const cancelTransaction = async (transactionId: string) => {
  const response = await apiClient({
    url: `/auth/cancel`,
    method: "POST",
    data: { id: transactionId },
  });
  return response.data;
};

export const useCancelTransaction = () =>
  useMutation({
    onError: (error) => {
      captureException(error, {
        tags: {
          operation: "cancelTransaction",
          errorType: error.name || "UnknownError",
        },
        extra: {
          apiEndpoint: "/auth/cancel",
        },
        level: "error",
      });
    },
    mutationFn: (transactionId: string) => cancelTransaction(transactionId),
  });
